/** SamplingIssuesSlot — edit-only panels: sampling, R37 checklist link,
 *  issues panel. */
import { Button } from "@/components/ui/button";
import BookingSamplingPanel from "@/components/BookingSamplingPanel";
import BookingIssuesPanel from "@/components/BookingIssuesPanel";

export default function SamplingIssuesSlot({ values, ctx }) {
  const { booking, isEdit, user } = ctx;

  if (!isEdit || !booking?.id) {
    return (
      <p className="text-xs text-slate-500 italic">
        Save the booking first, then raise QA issues / NCRs from this tab.
      </p>
    );
  }
  return (
    <>
      <BookingSamplingPanel bookingId={booking.id} currentUserId={user?.id} />
      <div className="flex items-center justify-between rounded-md border bg-slate-50 px-3 py-2.5">
        <div>
          <div className="text-sm font-semibold">Intake Form — 5-stage sign-off</div>
          <div className="text-xs text-slate-500">
            Office → Gate → Pre-load → During-load → Post-load
          </div>
        </div>
        <a href={`/dock/checklist/${booking.id}`} target="_blank" rel="noreferrer"
           data-testid="open-checklist-link">
          <Button size="sm" variant="outline" type="button">Open checklist</Button>
        </a>
      </div>
      <BookingIssuesPanel
        bookingId={booking.id}
        siteId={values.site_id}
        currentUserId={user?.id}
        currentRole={user?.role || user?.app_metadata?.role}
      />
    </>
  );
}
